module.exports = __webpack_public_path__ + "static/img/arouse.632cd8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/arouse.png
// module id = Ncfs
// module chunks = 6